module.exports = __webpack_public_path__ + "img/photo.4f33a641.png";